<template>
  <!-- 最顶部的小导航栏 -->
  <div
    class="head-nav"
    :class="headNavHover || scroll ? 'headHover' : ''"
    @mouseenter="headNavEnter"
    @mouseleave="headNavLeave"
  >
    <div class="head-nav_container align-center justify-between">
      <!-- 鹏华logo -->
      <div class="nav_container_log pointer" @click="logoClick">
        <img
          src="@/assets/images/logo.png"
          alt=""
          v-if="headNavHover || scroll"
        />
        <img src="@/assets/images/logo-white.png" alt="" v-else />
      </div>
      <!-- 菜单 -->
      <div class="nav_container_menu align-center">
        <div
          class="menu-main_item pointer align-center"
          v-for="(item, index) in menuList"
          :key="index"
          :class="item.hover ? 'hover' : ''"
          @mouseenter="labelEnter(index)"
          @mouseleave="labelLeave(index)"
        >
          <div class="main_item_label" @click="menuClick(item)">
            {{ item.label }}
          </div>
          <div
            class="main_item_line"
            :class="item.hover ? 'main_item_lineShow' : ''"
          ></div>
          <div
            ref="subMenu"
            class="subMenu flex-col align-center"
            :style="{
              height: item.height
            }"
          >
            <div
              class="subMenu-item"
              v-for="(subItem, subIndex) in item.menuList"
              :key="subIndex"
              @click="subMenuClick(item, subItem)"
            >
              {{ subItem.label }}
            </div>
          </div>
        </div>
      </div>
      <!-- 电话 -->
      <div class="nav_container_tel align-center">
        <div class="tel">Tel：<span>+86-400-6788-533</span></div>
        <div class="line"></div>
        <div class="chinese align-end pointer" @click="chineseHandle">
          <img
            src="@/assets/images/language.png"
            alt=""
            v-if="headNavHover || scroll"
          />
          <img src="@/assets/images/language-white.png" alt="" v-else />
          <div>CN</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { envConfig } from '@const/env'
export default {
  name: 'HeadNav',
  components: {},
  props: {
    scroll: Boolean
  },
  data() {
    return {
      menuList: [
        {
          label: 'Home',
          hover: false,
          routerLink: '/home',
          height: null,
          style: {},
          menuList: []
        },
        {
          label: 'About Us',
          routerLink: '/aboutUs',
          hover: false,
          height: null,
          style: {},
          menuList: [
            {
              label: 'Company Overview',
              value: '1'
            },
            {
              label: 'Awards & Honors',
              value: '2'
            },
            {
              label: 'Our Culture',
              value: '3'
            },
            {
              label: 'Our Journey',
              value: '4'
            },
            {
              label: 'Contact Us',
              value: '5'
            }
          ]
        },
        {
          label: 'Fund List',
          hover: false,
          routerLink: '/fundMarket',
          height: null,
          style: {},
          menuList: [
            {
              label: 'Equity Fund',
              value: 'STOCK_FUND'
            },
            {
              label: 'Hybrid Fund',
              value: 'MIX_FUND'
            },
            {
              label: 'Bond Fund',
              value: 'BOND_FUND'
            },
            {
              label: 'Index Fund',
              value: 'INDEX_FUND'
            },
            {
              label: 'Money Market Fund',
              value: 'CURRENCY_FUND'
            },
            {
              label: 'QDII',
              value: 'QDII_FUND'
            },
            {
              label: 'FOF',
              value: 'FOF_FUND'
            },
            {
              label: 'REITs',
              value: 'REITS_FUND'
            }
          ]
        },
        {
          label: 'ESG',
          hover: false,
          routerLink: '/ESG',
          height: null,
          style: {},
          menuList: [
            {
              label: 'Investment Philosophy',
              value: '1'
            },
            {
              label: 'Research Practice',
              value: '2'
            },
            {
              label: 'Honors & Awards',
              value: '3'
            },
            {
              label: 'Investment Actions',
              value: '4'
            },
            {
              label: 'Information Disclosure',
              value: '5'
            },
          ]
        },
      ],
      headNavHover: false,
      logoShow: false,
      logoWhiteShow: true
    }
  },
  mounted() {
    const list = this.$refs.subMenu.map((el) => {
      return el.clientHeight + 'px'
    })
    this.refList = cloneDeep(list)
    this.menuList.forEach((el, index) => {
      el.height = this.refList[index].clientHeight + 'px'
    })
    this.menuList.forEach((el) => {
      el.height = 0 + 'px'
    })
  },
  methods: {
    // 前往中文官网
    chineseHandle() {
      let env = envConfig()
      let link = '';
      if (env.MODE == 'cg') {
        link = env.HOST + '/home'
      } else if (env.MODE == 'pre') {
        link =  env.HOST + '/pre_gweb/home'
      } else if (env.MODE == 'prod') {
        link = env.HOST + '/home'
      } else if (env.MODE == 'prod_parallel') {
        link = env.HOST + '/parallel/home'
      }
      window.open(link)
    },
    // 前往首页
    logoClick() {
      this.$router.gotoPage('/home')
    },
    // 父菜单点击
    menuClick(item) {
      if (item.routerLink) {
        this.$router.gotoPage({
          path: item.routerLink
        })
      } else if (item.link) {
        window.open(item.link)
      }
    },
    // 子菜单点击
    subMenuClick(item, subItem) {
      // 父菜单有路由地址
      if (item.routerLink) {
        if (subItem.value) {
          this.$router.gotoPage({
            path: item.routerLink,
            query: { value: subItem.value }
          })
        } else if (subItem.routerLink) {
          this.$router.gotoPage({
            path: subItem.routerLink
          })
        }
      } else {
        if (subItem.link) {
          window.open(subItem.link)
        } else if (subItem.routerLink) {
          this.$router.gotoPage({
            path: subItem.routerLink,
            query: {
              value: subItem.value
            }
          })
        }
      }
    },
    // 菜单项鼠标移入
    labelEnter(index) {
      this.menuList[index].hover = true
      this.menuList[index].height = this.refList[index]
    },
    // 菜单项鼠标移出
    labelLeave(index) {
      this.menuList[index].hover = false
      this.menuList[index].height = '0px'
      this.subMenuShow = false
    },
    // 头部鼠标移入
    headNavEnter() {
      this.headNavHover = true
    },
    // 头部鼠标移出
    headNavLeave() {
      this.headNavHover = false
    }
  }
}
</script>
<style lang="scss" scoped>
.head-nav {
  width: 100%;
  height: 56px;
  transition: background-color 0.5s;
  color: #ffffff;
  .head-nav_container {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
    .chinese {
      img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }
    }
    .nav_container_tel {
      font-size: 12px;
      .line {
        width: 1px;
        height: 12px;
        background: #bbbbbb;
        margin: 0 16px;
      }
      .tel {
        span {
          font-weight: 600;
        }
      }
    }
    .nav_container_menu {
      height: 100%;
      box-sizing: border-box;
      z-index: 1;
      .menu-main_item {
        margin: 0 30px;
        height: 100%;
        font-size: 14px;
        box-sizing: border-box;
        position: relative;
        white-space: nowrap;
        .main_item_line {
          width: 0;
          height: 2px;
          background: #c73128;
          position: absolute;
          bottom: 0;
          left: 50%;
          transition: width 0.3s;
          transform: translateX(-50%);
        }
        .main_item_lineShow {
          width: 100%;
        }
        .main_item_label:hover {
          color: #c73128;
        }
        .subMenu {
          position: absolute;
          top: 100%;
          left: 50%;
          background: #ffffff;
          border-radius: 0px 0px 8px 8px;
          transform: translateX(-50%);
          transition: height 0.5s;
          overflow: hidden;
          padding: 0 40px;
          box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 10px 0px;
          .subMenu-item:hover {
            color: #c73128;
          }
          .subMenu-item {
            padding: 10px 0;
            white-space: nowrap;
            text-align: center;
            color: #000000;
          }
        }
      }
    }
    .nav_container_log {
      width: 200px;
      height: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.headHover {
  background-color: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/HeadNav.vue